import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  [<path fill="url(#a)" d="M.7881 0h207.424v190H.7881z" key="0" />,<defs key="1"><pattern id="a" width="1" height="1" patternContentUnits="objectBoundingBox"><use xlinkHref="#b" transform="matrix(.0005 0 0 .00055 0 -.0459)" /></pattern></defs>,]
, 'GeneralNoCompletedJobsx');
